import { render, staticRenderFns } from "./PostBottomThemeAndSentiment.vue?vue&type=template&id=7d47fb43&scoped=true&"
import script from "./PostBottomThemeAndSentiment.vue?vue&type=script&lang=js&"
export * from "./PostBottomThemeAndSentiment.vue?vue&type=script&lang=js&"
import style0 from "./PostBottomThemeAndSentiment.vue?vue&type=style&index=0&id=7d47fb43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d47fb43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {VCombobox})
